const _apiURLMap = {
  'dojo.objectively.ai': 'https://neural1-api.azurewebsites.net',
  'dojo.objectively.win': 'https://neural1-api.azurewebsites.net',
  'cerebral1.azurewebsites.net': 'https://neural1-api.azurewebsites.net',
  'cerebral1-east.azurewebsites.net': 'https://neural1-api.azurewebsites.net',
  'cerebral2.azurewebsites.net': 'https://neural2-api.azurewebsites.net',
  'cerebral2-east.azurewebsites.net': 'https://neural2-api.azurewebsites.net',
  'cerebral3.azurewebsites.net': 'https://neural3-api.azurewebsites.net',
  localhost: 'http://localhost:3000',
};
const _getPicadorBaseUrl = () => {
  const envUrl = import.meta.env.VITE_PICADOR_BASE_URL;
  if (envUrl) return envUrl.replace(/\/+$/, '');
  return _apiURLMap[window.location.hostname];
};
export const getBaseUrl = _getPicadorBaseUrl;

const _picadorURL = _getPicadorBaseUrl();
const authorization = ''; // `Bearer `;

export const baseURL = _picadorURL;
export const apiVersion = `/api/v1`;
export const apiVersion2 = `/api/v2`;
export const authURL = `/.auth/me`;
export const loginURL = `/.auth/login/aad`;
export const xhrPath = {
  auth: `/.auth/me`,
  api: `/app`,

  userDocuments: ({ documentID }) =>
    `/api/v1/user/documents` + (documentID ? `/${documentID}` : ''),

  userAccount: '/api/v1/user',
  userAccount2: '/api/v2/users',
  userDebates: '/api/v2/debates',
  organization: '/api/v1/organization',
  basisUpload: 'api/v1/basis_upload',
  teamLeadAccess: 'api/v1/team_lead_access',
  InviteList: '/api/v1/document_invitees',
  contacts: ({ contactID }) => '/api/v1/contacts' + (contactID ? `/${contactID}` : ''),

  debate: ({ debateID, documentID }) =>
    apiVersion +
    '/debate' +
    (debateID ? `/${debateID}` : '') +
    (documentID ? `/document/${documentID}` : ''),

  debates: ({ debateID, documentID }) =>
    apiVersion2 +
    '/debates' +
    (debateID ? `/${debateID}` : '') +
    (documentID ? `/document/${documentID}` : ''),

  document: ({ documentID, citationID }) =>
    '/api/v1/document' +
    (documentID ? `/${documentID}` : '') +
    (citationID ? `/citation/${citationID}` : ''),

  documents: ({ documentID, citationID }) =>
    '/api/v2/documents' +
    (documentID ? `/${documentID}` : '') +
    (citationID ? `/citation/${citationID}` : ''),

  publicDocument: ({ documentID, citationID }) =>
    '/api/v2/public/documents' +
    (documentID ? `/${documentID}` : '') +
    (citationID ? `/citation/${citationID}` : ''),

  sourceDocument: ({ sourceDocumentID }) =>
    apiVersion2 + '/source_document' + (sourceDocumentID ? `/${sourceDocumentID}` : ''),

  team: ({ teamID }) => '/api/v1/team' + (teamID ? `/${teamID}` : ''),
  teamList: '/api/v1/team',
  teamMember: teamID => (teamID ? `/api/v1/team/${teamID}/member` : '/api/v1/team/member'),

  teamMemberSubmitAnnotations: teamID => `/api/v1/team/${teamID}/submit-annotations`,

  inviteOpposition: teamID => `/api/v1/team/${teamID}/opposition`,
  inviteCohort: teamID => `/api/v1/team/${teamID}/cohort`,

  logger: ({ sessionId }) => (sessionId ? `/api/v1/logger/${sessionId}/log` : '/api/v1/logger'),

  invitation: '/api/v1/invitation',
  challenge: '/api/v1/challenge',
  challengeDetails: '/api/v1/challenge_details',
  directInvite: '/api/v1/direct_invite',

  counterpoint: ({
    counterpointID,
    roundCounterpointID,
    annotationID,
    teamReplyID,
    citationID,
    citationDocumentID,
  }) =>
    `/api/v1/counterpoint` +
    (counterpointID ? `/${counterpointID}` : '') +
    (roundCounterpointID ? `/${roundCounterpointID}` : '') +
    (annotationID ? `/${annotationID}` : '') +
    (teamReplyID ? `/teamReply/${teamReplyID}` : '') +
    (citationID ? `/citation/${citationID}` : '') +
    (citationDocumentID ? `/${citationDocumentID}` : ''),

  instructions: teamID => `/api/v1/instructions/${teamID}`,

  publicLink: ({ publicLinkId, documentId, annotationLikeId }) =>
    '/api/v1/public' +
    (publicLinkId ? `/${publicLinkId}` : '') +
    (documentId ? `/document/${documentId}` : '') +
    (annotationLikeId ? `/like/${annotationLikeId}` : ''),
  // ###
  publicDebate: ({ publicLinkId }) => '/api/v1/public/debate/' + publicLinkId,
  // publicDebateDoc: ({ publicLinkId }) => '/api/v1/public_debate/' + publicLinkId,
  share: () => '/api/v1/share',
  visitor: () => '/api/v2/visitors',
  // visitor: ({ visitorId, documentId, publicLinkIds }) =>
  //   "/api/v1/visitor" +
  //   (visitorId ? `/${visitorId}` : "") +
  //   (documentId ? `/document/${documentId}` : "") +
  //   (publicLinkIds ? `/publicLink/${publicLinkIds.join(",")}` : ""),
};

/**
 * Axios initialization
 */
export const headers = {
  // accept: "application/json",
  Authorization: authorization,
};

const _initAxiosBase = function (baseURL) {
  return function (axios, access_token) {
    axios.defaults.baseURL = baseURL;
    axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
    axios.defaults.headers.post['Content-Type'] = 'application/json';
  };
};

const _initPicador = function (axios, access_token) {
  _initAxiosBase(_picadorURL)(axios, access_token);
};

export const initPicador = _initPicador;
